import { Component, ChangeDetectionStrategy, ViewChild, ViewContainerRef, Input } from '@angular/core';
import { TrackingMapsRenderService } from '../tracking-maps-render.service';
import { filter, take } from 'rxjs/operators';
import { TransportMode } from '../../../common/constants';
import { MapPoint, MapStop, MapTrackingPoints } from '../../../common/models';
import { MapComponent } from './map/map.component';

@Component({
  selector: 'lib-tracking-map',
  templateUrl: './tracking-map.component.html',
  styleUrls: ['./tracking-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackingMapComponent {
  @Input() trackingTransportMode: TransportMode;
  @Input() set mapData(mapData: MapTrackingPoints<MapStop, MapPoint>) {
    if (mapData) {
      this.scriptAppendSubscription(mapData);
    }
  }

  @ViewChild('mapContainer', { read: ViewContainerRef, static: true })
  mapContainerRef: ViewContainerRef;

  constructor(private trackingMapsRenderService: TrackingMapsRenderService) {}

  private scriptAppendSubscription(mapData: MapTrackingPoints<MapStop, MapPoint>): void {
    this.trackingMapsRenderService.isGoogleMapApiScriptAppended$.pipe(filter(Boolean), take(1)).subscribe(() => {
      const component = this.trackingMapsRenderService.render<MapComponent>(this.mapContainerRef, MapComponent);
      component.instance.trackingTransportMode = this.trackingTransportMode;
      component.instance.mapData = mapData;
    });
  }
}
